<template>
  <v-container fluid>
    <v-row class="content-row auto-scrollbar-padding">
      <v-col cols="4">
        <v-subheader>Input</v-subheader>
        <v-row>
          <v-col cols="10">
            <v-select
              v-model="input"
              :items="inputItems"
              item-value="id"
              menu-props="auto"
              label="Action"
              hide-details
              single-line
            ></v-select>
          </v-col>
          <v-col cols="2">
            <v-btn icon large color="green" @click="sendAction()">
              <v-icon>mdi-chevron-double-right</v-icon>
            </v-btn>
          </v-col>
        </v-row>
        <v-subheader>Clients</v-subheader>
        <v-row v-for="(client, indexC) in clients" :key="indexC" class="clientRow">
          <v-col cols="4">{{ `(${client.conn})${(client.user.logged ? ` \n#${client.user.id}` : ``)}` }}</v-col>
          <v-col cols="5">{{ `${(client.user.logged ? client.user.name + '\n(' + client.user.function + ')\n' : '' )}${client.ip}` }}</v-col>
          <v-col cols="3">
            <v-btn small color="warning" @click="logoutClient(client.conn)">Logout</v-btn><br/>
            <v-btn small color="error mt-3" @click="kickClient(client.conn)">Kick</v-btn>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="8">
        <v-subheader>Output</v-subheader>
        <v-container fluid class="amber lighten-5" v-bar="{ preventParentScroll: true, scrollThrottle: 30 }">
          <div>
            <v-textarea
              v-model="output"
              auto-grow
            ></v-textarea>
          </div>
        </v-container>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import appdata from '@/mixins/appdata'

export default {
  mixins: [ appdata ],
  data: () => ({
    input: 0,
    output: '',
    clients: '',
    inputItems: [
      { value: 0, text: 'Get Data' },
      { value: 1, text: 'Force Refresh All' },
      { value: 2, text: 'Close to Maintenance' },
      { value: 3, text: 'Open from Maintenance' },
      { value: 4, text: 'Logoff All Users' },
      { value: 5, text: 'Kick All Connections' }
    ]
  }),
  computed: {
    ADMIN_PROTOCOL () {
      return this.socketInfo.xProtocolAdm
    }
  },
  watch: {
    ADMIN_PROTOCOL: {
      deep: true,
      handler () {
        this.clients = this.ADMIN_PROTOCOL.data.clients
        this.output = this.ADMIN_PROTOCOL.output
      }
    }
  },
  methods: {
    sendAction () {
      this.$store.dispatch('socket/ADM_PROTOCOL', { type: this.input })
    },
    refreshData () {
      this.$store.dispatch('socket/ADM_PROTOCOL', { type: 0 })
    },
    logoutClient (conn) {
      this.$store.dispatch('socket/ADM_PROTOCOL', { type: 6, target: conn })
    },
    kickClient (conn) {
      this.$store.dispatch('socket/ADM_PROTOCOL', { type: 7, target: conn })
    }
  },
  created () {
    this.sendAction()
  }
}
</script>

<style scoped>
.v-subheader {
    padding-left: 0px;
}
.v-input {
    padding-top: 0px !important;
}
.v-btn:before {
    background-color: currentColor;
}
.clientRow {
  background: #f9f9f9;
  border-bottom: 2px dashed #ccc;
  padding: 5px;
}
.outputArea {
  max-height: 500px;
  overflow: auto;
}
</style>
